import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as SurveyActions from './survey.actions'
import { SurveyService } from '../services/survey.service'




@Injectable()
export class SurveyEffects {


  loadSurvey$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(SurveyActions.loadSurvey),
      exhaustMap(() => {
        return this.surveyService.getSurvey().pipe(
          map(data =>{
            return SurveyActions.loadSurveySuccess({ data })} ),
          catchError(error => of(SurveyActions.loadSurveyFailure({ error }))))
      })
    );
  });

  loadRecord$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(SurveyActions.loadRecord),
      exhaustMap((action: any) => {
        return this.surveyService.getSurveyRecord(action.payload).pipe(
          map(data => {
            return SurveyActions.loadRecordSuccess({ data });
          }),
          catchError(error => of(SurveyActions.loadRecordFailure({ error }))))
      })
    );
  });


  constructor(
    private actions$: Actions,
    private surveyService: SurveyService,
  ) {}

}
